var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  A JS npm library for helping IPFS peers coordinate, find a common interest,
  and stay connected around that interest.

  See the specification document in the dev-docs directory.
*/
// local libraries
var Adapters = require('./lib/adapters');

var Controllers = require('./lib/controllers');

var UseCases = require('./lib/use-cases');

var IpfsCoord = /*#__PURE__*/function () {
  "use strict";

  function IpfsCoord() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, IpfsCoord);

    // Input Validation
    if (!localConfig.ipfs) {
      throw new Error('An instance of IPFS must be passed when instantiating the ipfs-coord library.');
    }

    if (!localConfig.bchjs) {
      throw new Error('An instance of @psf/bch-js must be passed when instantiating the ipfs-coord library.');
    }

    this.type = localConfig.type;

    if (!this.type) {
      throw new Error('The type of IPFS node (browser or node.js) must be specified.');
    } // 'embedded' node type used as default, will use embedded js-ipfs.
    // Alternative is 'external' which will use ipfs-http-client to control an
    // external IPFS node.


    this.nodeType = localConfig.nodeType;

    if (!this.nodeType) {
      console.log('No node type specified. Assuming embedded js-ipfs.');
      this.nodeType = 'embedded';
    } // Retrieve and/or set the debug level.
    // 0 = no debug information.
    // 1 = status logs
    // 2 = verbose errors about peer connections


    this.debugLevel = parseInt(localConfig.debugLevel);
    if (!this.debugLevel) this.debugLevel = 0;
    localConfig.debugLevel = this.debugLevel;
    console.log("ipfs-coord debug level: ".concat(localConfig.debugLevel)); // localConfiguration of an optional 'status' log handler for log reports. If none
    // is specified, defaults to console.log.

    if (localConfig.statusLog) {
      this.statusLog = localConfig.statusLog;
    } else {
      this.statusLog = console.log;
    } // If the statusLog handler wasn't specified, then define it.


    localConfig.statusLog = this.statusLog; // localConfiguration of an optional 'private' log handler for recieving e2e
    // encrypted message. If none is specified, default to console.log.

    if (localConfig.privateLog) {
      this.privateLog = localConfig.privateLog;
    } else {
      this.privateLog = console.log;
    } // If the privateLog handler wasn't specified, then define it.


    localConfig.privateLog = this.privateLog; // Load the adapter libraries.

    this.adapters = new Adapters(localConfig);
    localConfig.adapters = this.adapters; // Load the controller libraries

    this.controllers = new Controllers(localConfig);
    localConfig.controllers = this.controllers; // Load the Use Cases

    this.useCases = new UseCases(localConfig);
  } // Returns a Promise that resolves to true once the IPFS node has been
  // initialized and has had a chance to connect to circuit relays and
  // coordination pubsub channels.


  _createClass(IpfsCoord, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.adapters.ipfs.start();

              case 2:
                _context.next = 4;
                return this.useCases.thisNode.createSelf({
                  type: this.type
                });

              case 4:
                this.thisNode = _context.sent;
                _context.next = 7;
                return this.useCases.pubsub.initializePubsub(this.thisNode);

              case 7:
                _context.next = 9;
                return this.controllers.timer.startTimers(this.thisNode, this.useCases);

              case 9:
                // Kick-off initial connection to Circuit Relays and Peers.
                // Note: Deliberatly *not* using await here, so that it doesn't block startup
                // of ipfs-service-provider.
                this._initializeConnections();

                return _context.abrupt("return", true);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }() // This function kicks off initial connections to the circuit relays and then
    // peers. This function is intended to be called once at startup. This handles
    // the initial connections, but the timer-controller manages the connections
    // after this initial function.

  }, {
    key: "_initializeConnections",
    value: function () {
      var _initializeConnections2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.useCases.relays.initializeRelays(this.thisNode);

              case 3:
                console.log('Initial connections to Circuit Relays complete.'); // Load list of Circuit Relays from GitHub Gist.

                _context2.next = 6;
                return this.useCases.relays.getCRGist(this.thisNode);

              case 6:
                console.log('Finished connecting to Circuit Relays in GitHub Gist.');
                _context2.next = 9;
                return this.useCases.thisNode.refreshPeerConnections();

              case 9:
                console.log('Initial connections to subnet Peers complete.');
                return _context2.abrupt("return", true);

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                console.error('Error in _initializeConnections(): ', _context2.t0); // throw err
                // Do not throw errors as it will prevent the node from starting.

                return _context2.abrupt("return", false);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      function _initializeConnections() {
        return _initializeConnections2.apply(this, arguments);
      }

      return _initializeConnections;
    }()
  }]);

  return IpfsCoord;
}();

module.exports = IpfsCoord;